import React from 'react';
import {Container} from "react-bootstrap";

function Bulletin() {
  return (
    <Container>

      <h2 className="mb-4">iStore Tech Bulletin.</h2>


      <article>
        <h3>Got Solar? Add an iStore as a Thermal Battery</h3>

        <p>Historically, generating excess energy from your rooftop solar system was financially beneficial as you could sell this excess energy back to the grid at a high rate.</p>

        <p>As an example, for systems installed before July 2011 in Western Australia, the excess electricity could be sold back to the grid for up to 47 cents per kWh exported. This meant you would have little to nothing to pay on your bills. Nowadays, the going rate for feed-in tariffs are as low as 2.5 cents, yet you are paying around 30 cents per kWh to buy that energy back in the evenings when your panels aren’t producing.</p>

      </article>

    </Container>
  );
}

export default Bulletin;
